import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ContentApiService {
  private apiUrl = environment.externalApiUrl;

  constructor(private http: HttpClient) {}

  // Pages
  getPages(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/pages`);
  }

  getHomepage(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/pages/homepage`);
  }

  getPageBySlug(slug: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/pages/${slug}`);
  }

  // Menus
  getMenus(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/menus`);
  }

  getMenuBySlug(slug: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/menus/${slug}`);
  }

  // Company
  getCompanyInfo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/company`);
  }

  getLocations(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/company/locations`);
  }

  getDivisions(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/company/divisions`);
  }

  getProjects(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/company/projects`);
  }

  // Division
  getDivisionById(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/divisions/${id}`);
  }

  getDivisionLocations(divisionId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/divisions/${divisionId}/locations`);
  }

  // Gallery
  getGalleryById(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/galleries/${id}`);
  }

  // Slider
  getSliderById(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/sliders/${id}`);
  }

  // Blog
  getBlogCategories(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/blog/categories`);
  }

  getBlogPosts(categoryId?: string): Observable<any[]> {
    const params = categoryId ? `?categoryId=${categoryId}` : '';
    return this.http.get<any[]>(`${this.apiUrl}/blog/posts${params}`);
  }

  getBlogPostBySlug(slug: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/blog/posts/${slug}`);
  }

  // Forms
  getFormBySlug(slug: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/forms/${slug}`);
  }

  getFormById(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/forms/${id}`);
  }

  submitForm(formId: string, data: Record<string, any>): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/forms/${formId}/submissions`, data);
  }

  // Projects
  getProjectById(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/company/projects/${id}`);
  }
}
